import { useState } from "react";
import ChosenColor from "../GeneratePage/ChosenColor";
import DeleteSavedPalette from "./DeleteSavedPalette";
import "./SavedPalette.css";

function SavedPalette({colors, prompt, deleteFunc}) {
    const [isDeleteOpen, setIsDeleteOpen] = useState(false);

    const handleConfirmDelete = () => {
        if (deleteFunc) {
            deleteFunc();
        }
        setIsDeleteOpen(false);
    };

    return(
        <>
        <div className="paletteCard">
            {colors == null || colors.length == 0 ? null :
                <>
                    <ChosenColor color={colors[0]}></ChosenColor>
                    <ChosenColor color={colors[1]}></ChosenColor>
                    <ChosenColor color={colors[2]}></ChosenColor>
                    <ChosenColor color={colors[3]}></ChosenColor>
                </>
            }
            <div className="palette-details">
                <p className={colors == null || colors.length == 0 ? "palette-prompt--no-margin" : ""}>{prompt}</p>
                <div className={`palette-actions ${colors == null || colors.length == 0 ? "palette-actions--center" : ""}`}>
                    <button className="palette-action" type="button" label="Share" onClick={() => {alert("Sharing artwork feature is currently still under construction.")}}
                    style={{backgroundColor: "rgb(57, 101, 151)",}}>
                        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M9.61109 12.4L10.8183 18.5355C11.0462 19.6939 12.6026 19.9244 13.1565 18.8818L19.0211 7.84263C19.248 7.41555 19.2006 6.94354 18.9737 6.58417M9.61109 12.4L5.22642 8.15534C4.41653 7.37131 4.97155 6 6.09877 6H17.9135C18.3758 6 18.7568 6.24061 18.9737 6.58417M9.61109 12.4L18.9737 6.58417M19.0555 6.53333L18.9737 6.58417" stroke="#000000" stroke-width="2"></path> </g></svg>                   
                    </button>
                    <button className="palette-action" type="button" label="Finish" onClick={() => {alert("Tracking your daily art progress will be added later.")}}
                    style={{backgroundColor: "rgb(101, 141, 93)",}}>
                        <svg fill="#000000" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"><path d="M2,3H22V13H18V21H16V13H8V21H6V13H2V3M18.97,11L20,9.97V7.15L16.15,11H18.97M13.32,11L19.32,5H16.5L10.5,11H13.32M7.66,11L13.66,5H10.83L4.83,11H7.66M5.18,5L4,6.18V9L8,5H5.18Z"></path></g></svg>
                    </button>
                    <button className="palette-action" type="button" label="Erase" onClick={() => setIsDeleteOpen(true)}
                    style={{backgroundColor: "rgb(174, 14, 14)",}}>
                        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M18 6L17.1991 18.0129C17.129 19.065 17.0939 19.5911 16.8667 19.99C16.6666 20.3412 16.3648 20.6235 16.0011 20.7998C15.588 21 15.0607 21 14.0062 21H9.99377C8.93927 21 8.41202 21 7.99889 20.7998C7.63517 20.6235 7.33339 20.3412 7.13332 19.99C6.90607 19.5911 6.871 19.065 6.80086 18.0129L6 6M4 6H20M16 6L15.7294 5.18807C15.4671 4.40125 15.3359 4.00784 15.0927 3.71698C14.8779 3.46013 14.6021 3.26132 14.2905 3.13878C13.9376 3 13.523 3 12.6936 3H11.3064C10.477 3 10.0624 3 9.70951 3.13878C9.39792 3.26132 9.12208 3.46013 8.90729 3.71698C8.66405 4.00784 8.53292 4.40125 8.27064 5.18807L8 6" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
                    </button>
                </div>
            </div>
        </div>
        <DeleteSavedPalette
            open={isDeleteOpen}
            onCancel={() => setIsDeleteOpen(false)}
            onConfirm={handleConfirmDelete}
        />
        </>
    );
}


export default SavedPalette;